"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VectorTileLayer = void 0;
const VectorTileFeature_1 = require("./VectorTileFeature");
class VectorTileLayer {
    constructor(layer) {
        this.length = 0;
        this.name = layer.name;
        this._raw = layer;
        this.length = layer.features.length;
    }
    feature(i) {
        return new VectorTileFeature_1.VectorTileFeature(this._raw.features[i]);
    }
}
exports.VectorTileLayer = VectorTileLayer;
//# sourceMappingURL=VectorTileLayer.js.map